import React from "react";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    // Same as ProductScreen/BuyButtonArea, plus `marginTop: auto`: the cart is
    // often short enough not to scroll, and `sticky` alone only pins while the
    // containing block overflows the viewport. The auto margin pushes the bar
    // to the bottom of the (full-height) screen in that case.
    root: props => ({
        backgroundColor: props.options.buttonColor,
        bottom: 0,
        marginTop: 'auto',
        padding: '0 20px',
        position: 'sticky',
        width: '100%',
        zIndex: 99
    }),
    label: props => ({
        color: props.options.buttonTextColor,
        fontSize: 16,
        margin: 0,
        padding: '15px 0',
        textAlign: 'center',
    }),
}));

export default function BuyButtonArea({ colors }) {
    const classes = useStyles(colors);

    return (
        <div className={classes.root}>
            <p className={classes.label}>
                Continuar
            </p>
        </div>
    );
};